import React from "react"
import Card from "../../../../components/atoms/Card.atom"
import ProjectChip from "../../../../components/molecules/ProjectChip.molecule"
import { Ripple } from "primereact/ripple"

const ProjectCard = ({ client, project, teamMembers, disabled, onClick }) => {
  const getProjectLeadersFullName = () => {
    const membersInCharge =
      project?.membersInCharge?.map((id) => parseInt(id)) || []
    const leaders = teamMembers.filter((member) =>
      membersInCharge.includes(parseInt(member.id))
    )
    if (leaders.length === 0) return "Sin asignación"
    const title = leaders
      .map((leader) => `${leader.name} ${leader.lastName}`)
      .join(", ")

    const label = leaders.map((leader) => leader.nameTag).join(", ")
    return <span title={title}>{label}</span>
  }
  return (
    <Card
      className={`project-card shadow-2 cursor-pointer p-ripple ${
        disabled ? "p-disabled" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="flex flex-column gap-2">
        <div className="project-chip-title flex gap-2">
          <ProjectChip clientCode={client?.code} projectCode={project?.code} />
          <h4 className="font-cairo text-xl font-semibold m-0 white-space-nowrap text-overflow-ellipsis overflow-hidden">
            {project.name}
          </h4>
        </div>
        <div className="project-leader flex justify-content-between gap-2">
          <span className="font-mulish text-base font-base clr-secondary m-0">
            Responsable(s)
          </span>
          <span className="font-mulish text-base font-base clr-secondary m-0 white-space-nowrap text-overflow-ellipsis overflow-hidden">
            {getProjectLeadersFullName()}
          </span>
        </div>
        <div className="project-status flex justify-content-between gap-2">
          <span className="font-mulish text-base font-base clr-secondary m-0">
            Estatus
          </span>
          <span className="font-mulish text-base font-base clr-secondary m-0">
            {project.active ? "Activo" : "Inactivo"}
          </span>
        </div>
      </div>
      <Ripple />
    </Card>
  )
}

export default ProjectCard
